import React from 'react';
import { Typography, List, Divider, Space, Row, Col, Popconfirm } from 'antd';
import { DeleteOutlined, BookOutlined } from '@ant-design/icons';
import { Link as RouterLink } from 'react-router-dom';

import { AddsContainer } from './common';

const { Title, Text, Link } = Typography;

const labelStyle = (label) => ({
  fontWeight: 600,
  color: label === 'Fail' ? '#f5222d' : '#faad14',
});

const InspectionDefects = ({
  data,
  onDelete,
  itemKey,
  inspectionFormId,
  inspectionFormTitle,
}) => {
  if (!data.length) return;

  return (
    <>
      <Row
        style={{ margin: '10px' }}
        gutter={16}
        data-lineitem={itemKey.toString()}
      >
        <Col span={24}>
          <AddsContainer>
            <Row
              style={{
                alignItems: 'flex-start',
                marginBottom: 8,
                cursor: 'grab',
              }}
              gutter={16}
            >
              <Col
                style={{
                  width: 40,
                  textAlign: 'center',
                  paddingTop: '25px',
                }}
              >
                <BookOutlined style={{ fontSize: '32px' }} />
              </Col>
              <Col style={{ flex: 1, paddingLeft: 5 }}>
                <Row>
                  <Col span={23} style={{ borderBottom: '1px solid #d9d9d9' }}>
                    Inpection Defects -{' '}
                    <RouterLink
                      to={`/inspection-forms/forms/${inspectionFormId}/edit`}
                    >
                      {inspectionFormTitle}
                    </RouterLink>
                  </Col>
                  <Col span={1}></Col>
                </Row>
                <Row>
                  <Col span={23}>
                    {data.map((group, groupIndex) => (
                      <div
                        key={groupIndex}
                        style={{
                          width: '100%',
                          marginTop: '10px',
                        }}
                      >
                        <Text strong>{group.title}</Text>

                        <div style={{ paddingLeft: '15px' }}>
                          <List
                            itemLayout="horizontal"
                            bordered={false}
                            dataSource={group.sections}
                            split={false}
                            renderItem={(item, itemIndex) => {
                              const [label, description] =
                                Object.entries(item)[0];
                              return (
                                <List.Item
                                  actions={[
                                    <Popconfirm
                                      key="delete"
                                      title="Sure to delete?"
                                      okText="Yes"
                                      cancelText="No"
                                      onConfirm={() => {
                                        onDelete?.(group.title, description);
                                        console.log(group.title, description);
                                      }}
                                    >
                                      <DeleteOutlined
                                        style={{
                                          color: '#ff4d4f',
                                          cursor: 'pointer',
                                        }}
                                      />
                                    </Popconfirm>,
                                  ]}
                                >
                                  <Space>
                                    <Text style={labelStyle(label)}>
                                      {label}:
                                    </Text>
                                    <Text>{description}</Text>
                                  </Space>
                                </List.Item>
                              );
                            }}
                          />
                        </div>
                      </div>
                    ))}
                  </Col>
                </Row>
              </Col>
            </Row>
          </AddsContainer>
        </Col>
      </Row>
    </>
  );
};

export default InspectionDefects;
